import { CircleCheck, X } from 'lucide-react'

interface SuccessSnackbarProps {
  message: string
  description?: string
  onDismiss?: () => void
}

/** Presentation only; the caller owns visibility, placement and lifetime. */
export function SuccessSnackbar({ message, description, onDismiss }: SuccessSnackbarProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="bg-success flex items-center gap-2.5 rounded-lg px-3.5 py-3 text-white shadow-lg"
    >
      <CircleCheck aria-hidden="true" className="size-[18px] shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-[13px] leading-[1.3] font-medium">{message}</p>
        {description && <p className="mt-1 text-xs leading-[1.4]">{description}</p>}
      </div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Tutup notifikasi sukses"
          className="pointer-events-auto -my-3 -mr-3.5 grid size-11 shrink-0 place-items-center rounded-lg hover:bg-black/10"
        >
          <X aria-hidden="true" className="size-4" />
        </button>
      )}
    </div>
  )
}
